import * as React from "react";

function SvgChartLine(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 21"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M.83 12.13l1.63.41 1.23-2L1.35 10a1.09 1.09 0 00-1.35.79 1.11 1.11 0 00.83 1.34zm21.35.31l-5.36 4.91-6.29-5a1.2 1.2 0 00-.41-.2L9.28 12l-1.23 2 1.32.33 6.84 5.38a1 1 0 00.67.23 1.08 1.08 0 00.73-.28l6-5.53a1.12 1.12 0 00.08-1.56 1.08 1.08 0 00-1.51-.13zM10.42 7.06l5.87 3.82a1.08 1.08 0 001.48-.3l6-8.84A1.11 1.11 0 0023.53.2 1.07 1.07 0 0022 .48l-5.43 8-5.89-3.88a1.08 1.08 0 00-1.51.34l-9 14.36a1.12 1.12 0 00.34 1.53 1.12 1.12 0 00.58.17 1.09 1.09 0 00.91-.51z" />
    </svg>
  );
}

const MemoSvgChartLine = React.memo(SvgChartLine);
export default MemoSvgChartLine;
